import { normalizeAvailabilityForForm } from '../enums';

/**
 * Data Transfer Object for getting material data
 * Represents the MaterialDTO schema from the API
 */
export class GetMaterialDTO {
    constructor(materialData = {}) {
        this.id = materialData.id;
        this.community = materialData.community;
        this.name = materialData.name;
        this.path = materialData.path;
        this.banner = materialData.banner;
        const normalized = normalizeAvailabilityForForm(materialData.availability);
        this.availability = normalized !== undefined ? normalized : null;
        this.timestamps = materialData.timestamps;
        this.can_access = materialData.can_access;
        this.allow_download = materialData.allow_download ?? true;
    }

    /**
     * Convert to a plain object for internal use
     * @returns {Object}
     */
    toObject() {
        return {
            id: this.id,
            community: this.community?.id || this.community,
            name: this.name,
            path: this.path,
            banner: this.banner,
            availability: this.availability,
            timestamps: this.timestamps,
            can_access: this.can_access,
            allow_download: this.allow_download
        };
    }

    /**
     * Get community ID
     * @returns {number|undefined}
     */
    getCommunityId() {
        return typeof this.community === 'object'
            ? this.community?.id
            : this.community;
    }
}
